import AddIcon from '@mui/icons-material/Add';
import { Box, Chip, Popover } from '@mui/material';
import React from 'react';

import { TAG_PICKER_AVAILABLE_TAGS } from '../../../constants/templates';

interface IProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onTagClick?: (tag: string) => void;
}

export const TagPickerFloatButton = ({ anchorEl, onClose, onTagClick }: IProps) => {
  const handleTagClick = (tag: string) => {
    if (onTagClick) {
      onTagClick(tag);
    }
  };

  const chipStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 0.5,
    width: 'fit-content',
    height: 24,
    cursor: 'pointer',
    '& .MuiChip-label': {
      px: 0.75,
    },
    '& .MuiChip-icon': {
      mx: 0,
    },
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, padding: 2 }}>
        {TAG_PICKER_AVAILABLE_TAGS.map((tag) => (
          <Chip
            key={tag}
            label={tag}
            icon={<AddIcon fontSize="small" />}
            onClick={() => handleTagClick(tag)}
            sx={{
              ...chipStyles,
            }}
          />
        ))}
      </Box>
    </Popover>
  );
};
